// extracted by mini-css-extract-plugin
export default {"tasks":"iO-z","task":"jO-z","svg":"kO-z","text":"lO-z"};